export default __webpack_public_path__ + "static/media/labs (2).95f5abc7.JPG";